import React from "react";

const Footer = () => {
  return (
    <>
      <div
        className="ui inverted vertical footer segment"
        style={{ boxShadow: "0 50vh 0 50vh rgb(27, 28, 29)" }}
      >
        <div
          className="ui horizontal divider inverted"
          style={{ paddingTop: "10px" }}
        >
          <h2>Thanks For Visiting</h2>
        </div>
        <div className="ui container">
          <div className="ui stackable inverted divided equal height stackable grid">
            <div className="three wide column">
              <h4 className="ui inverted header">Main Menu</h4>
              <div className="ui inverted link list">
                <a href="/" className="item">
                  Home
                </a>
                <a href="/about-us" className="item">
                  About Us
                </a>
                <a href="/prices" className="item">
                  Prices
                </a>
              </div>
            </div>

            <div className="seven wide column">
              <h3 className="ui inverted header">Contact Us</h3>
              <h3>
                We are committed to help serving you the best detailing
                experience possible, please contact us using our contact
                details:
              </h3>
              <a href="tel:7202859250">
                <i class="phone icon"></i> (720)285 9250
              </a>
              &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="mailto: m.aljumaily5000@gmail.com">
                <i class="mail icon"></i>Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
